import Header from "quill/formats/header";

export default class CustomHeader extends Header {
    // Replace default tagName [H1, ..., H6] with H4 => convert each <h* /> tag to h4
    static tagName = ['H1', 'H2', 'H3', 'H4'];
}